import { V2File } from 'clients/api/fileUploads';

export type FileGQL = {
  uuid: string;
  name: string;
  contentType: string;
  size: number;
  previewWidth?: number;
  previewHeight?: number;
  url: string;
};

export function fileGQLFromV2File(v2File: V2File) {
  return {
    uuid: v2File.id,
    name: v2File.name,
    contentType: v2File.content_type,
    size: v2File.size,
    previewWidth: v2File.preview_width,
    previewHeight: v2File.preview_height,
    url: v2File.urls.cdn,
  }
}
